/**
 * @param {AttendanceCode} form
 * @returns {AttendanceCode}
 */
export function initAttendanceCode(form = {}) {
    return {
        ...(form || {}),

        name: form?.name || null,
        uses: form?.uses ?? true,
    };
}

/**
 * @typedef {object} AttendanceCode
 *
 * @property {string} name
 * @property {boolean} uses
 */
